module.exports = __webpack_public_path__ + "static/media/jolli.6f7794f1.svg";